import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  value: {
    default: 40,
    editor: 'number',
  },
  width: {
    default: '100px',
    editor: 'textbox',
  },
  accent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  shadow: {
    default: true,
    editor: 'checkbox',
  },
  textStyle: {
    editor: 'textbox',
    default: '',
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundKnobsV3React: Knobs = {
  ...PlaygroundKnobsV3,
  textStyle: { ...PlaygroundKnobs.textStyle, qualifierStart: '{', qualifierEnd: '}' },
};

const TextStyleKnobsReact: Knobs = {
  ...PlaygroundKnobs,
  textStyle: { ...PlaygroundKnobs.textStyle, qualifierStart: '{', qualifierEnd: '}' },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-progress-dounut where you can change all the attributes',
  coreComponent: {
    html: `<tag-progress-donut{{...knobs}}>
</tag-progress-donut>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
  <tag3-progress-donut{{...knobs}}>
</tag3-progress-donut>
  `,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: { jsx: `<TagProgressDonut{{...knobs}} />`, knobs: PlaygroundKnobs },
  reactWrapper_v3: { jsx: `<Tag3ProgressDonut{{...knobs}} />`, knobs: PlaygroundKnobsV3React },
};
const CustomStyleStory: Story = {
  title: 'Custom styling',
  description: 'Custom text style',
  coreComponent: {
    html: `<tag-progress-donut
  {{...knobs}}>
</tag-progress-donut>`,
    knobs: PlaygroundKnobs,
    knobInitialValues: {
      textStyle: '{"font-weight": "bold","font-size":"0.8em", "fill":"red"}',
    },
  },
  coreComponent_v3: {
    html: `
  <tag3-progress-donut{{...knobs}}>
</tag3-progress-donut>
  `,
    knobs: PlaygroundKnobsV3,
    knobInitialValues: {
      textStyle: '{"font-weight": "bold","font-size":"0.8em", "fill":"red"}',
    },
  },
  reactWrapper: {
    jsx: `<TagProgressDonut
  {{...knobs}} />`,
    knobs: TextStyleKnobsReact,
    knobInitalValues: {
      textStyle: '{"font-weight": "bold","font-size":"0.8em", "fill":"red"}',
    },
  },
  reactWrapper_v3: {
    jsx: `<Tag3ProgressDonut{{...knobs}} />`,
    knobs: PlaygroundKnobsV3React,
    knobInitalValues: {
      textStyle: '{"font-weight": "bold","font-size":"0.8em", "fill":"red"}',
    },
  },
};
export const TagProgressDonutDocs: Component = {
  type: 'component',
  name: 'progress-donut',
  description: 'Renders a progress donut bar',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'value',
      description: 'Render a % complete donut',
      type: 'number',
    },
    {
      name: 'accent',
      description: 'The fill colour',
      type: 'string',
      default: 'viridiangreen',
    },
    {
      name: 'width',
      description: 'The width of the component',
      type: 'string',
    },
    {
      name: 'textStyle',
      description: 'JSX style object in JSON to apply to the text',
      type: 'string',
    },
    {
      name: 'shadow',
      description: 'Whether to display the shadow',
      type: 'boolean',
      default: 'true',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory, CustomStyleStory],
};
